import MultiMediaIconSvg from "@/assets/icons/Multi-2-line 1.svg";

const MultiMediaIcon = ({ className, size }: { className?: string; size?: number }) => {
  return (
    <img
      src={MultiMediaIconSvg}
      alt="Multi Media Icon"
      className={className}
      style={{ width: size, height: size }}
    />
  );
};

export default MultiMediaIcon;
